import { React, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../src/redux/authSlice";
import LoginForm from "./components/LoginForm";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard/Dashboard";
import DevcoDashboard from "./components/devco/DevcoDashboard";
import Brand from "./components/brand/Brand";
import Merchent from "./components/merchent/Merchent";
import ProtectedRoute from "./components/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditMerchant from "./components/merchent/EditMerchant";
import AddMerchant from "./components/merchent/AddMerchant";
import MerchantInfo from "./components/merchent/MerchantInfo";
import TopUpHistory from "./components/merchent/TopUpHistory";
import MasterProduct from "./components//products/MasterProduct";
import ViewMasterProduct from "./components/products/ViewMasterProduct";
import AddMasterProduct from "./components/products/AddMasterProduct";
import EditMasterProduct from "./components/products/EditMasterProduct";
import Products from "./components/products/Products";
import ViewProduct from "./components/products/ProductInfo";
import EditProduct from "./components/products/EditProduct";
import AddProduct from "./components/products/AddProduct";
import ViewProfile from "./components/profile/userProfile";
import SettingsForm from "./components/settings/Settings";
import Forgot from "./components/forgot/Forgot";
import Orders from "./components/orders/Orders";
import Register from "./components/register/Register";
import MerchantRequests from "./components/merchent/MerchantRequests";
import EditMerchantRequest from "./components/merchent/EditMerchantRequest";
import MerchantAgreement from "./components/merchent/MerchantAgreement";
import MerchantAgreementView from "./components/merchent/MerchantAgreementView";
import OrderInfo from "./components/orders/oderInfo/oderInfo";
import AddOrder from "./components/orders/AddOrder";
import Details from "./components/orders/orders_details/Orders_details";
import CreateOrder from "./components/orderProduct/createOrder";
import PurchaseProduct from "./components/orderProduct/purchaseProduct";
import Reports from "./components/reports/Reports";
import OrdersReport from "./components/orders/ViewOrder";
import TopupReport from "./components/orders/ViewOrderTopup";
import AdminAgents from "./components/adminAgents/AdminAgents";
import AddAgent from "./components/adminAgents/addAgent/AddAgent";
import ViewAdminAgents from "./components/adminAgents/ViewAdminAgents";
import EditAdminAgents from "./components/adminAgents/EditAdminAgents";
import CustomerSupport from "./components/customerSupport/CustomerSupport";
import AddSupport from "./components/customerSupport/addCustomerSupport/index";
import EditSupport from "./components/customerSupport/EditCSA";
import ViewSupport from "./components/customerSupport/ViewCSA";
import Logs from "./components/logs/Logs";
import BulkUpload from "./components/bulkUpload/BulkUpload";
import CustomerInfo from "./components/customerInfo/index";
import EditCustomerInfo from "./components/customerInfo/edit";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import ResellerType from "./components/resellerType/ResellerType";
import Reset from "./components/reset/Reset";
import { setOnTokenExpiredCallback } from "../src/api/apiCall";
import { AccessControl } from "../src/helpers/roles";
import ActivityLogs from "./components/logs/ActivityLogs";
import MasterStockHistory from "./components//products//MasterStockHistory";
import StockTransfer from "./components/stockTransfer/StockTransfer";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setOnTokenExpiredCallback(() => {
      dispatch(logout());
      window.location.href = "/login";
    });

    return () => setOnTokenExpiredCallback(null);
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/register" element={<Register />} />
        <Route path="/state-password/:id" element={<Reset />} />

        {/* Protected routes inside Layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route
            path="/dashboard"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.DASHBOARD}>
                <Dashboard />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/devco-dashboard"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.DEVCO_DASHBOARD}>
                <DevcoDashboard />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/brands"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.BRANDS}>
                <Brand />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/merchants"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MERCHANTS}>
                <Merchent />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/edit-merchants/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.EDIT_MERCHANTS}>
                <EditMerchant />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/add-merchants"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADD_MERCHANTS}>
                <AddMerchant />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-merchants/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.VIEW_MERCHANTS}>
                <MerchantInfo />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/merchants-topup/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MERCHANTS_TOPUP}>
                <TopUpHistory />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/master"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MASTER_PRODUCT}>
                <MasterProduct />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-master/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MASTER_PRODUCT}>
                <ViewMasterProduct />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/edit-master/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MASTER_PRODUCT}>
                <EditMasterProduct />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/add-master"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MASTER_PRODUCT}>
                <AddMasterProduct />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/products-denomination"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PRODUCT}>
                <Products />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-products/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PRODUCT}>
                <ViewProduct />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/edit-products/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PRODUCT}>
                <EditProduct />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/add-products"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PRODUCT}>
                <AddProduct />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PROFILE}>
                <ViewProfile />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/profile-settings"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PROFILE}>
                <SettingsForm />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/merchant-requests"
            element={
              <RoleProtectedRoute
                allowedRoles={AccessControl.MERCHANT_REQUESTS}
              >
                <MerchantRequests />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/merchant-request/:id"
            element={
              <RoleProtectedRoute
                allowedRoles={AccessControl.MERCHANT_REQUESTS}
              >
                <EditMerchantRequest />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/merchant-agreement/:id"
            element={
              <RoleProtectedRoute
                allowedRoles={AccessControl.MERCHANT_REQUESTS}
              >
                <MerchantAgreement />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-merchant-agreement/:id"
            element={
              <RoleProtectedRoute
                allowedRoles={AccessControl.MERCHANT_REQUESTS}
              >
                <MerchantAgreement />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-merchant-agreement/"
            element={
              <RoleProtectedRoute
                allowedRoles={AccessControl.MERCHANTS_AGREEMENT_VIEW}
              >
                <MerchantAgreementView />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/orders/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ORDERS}>
                <Orders />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/orders-info/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ORDERS}>
                <OrderInfo />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/add-orders/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADD_ORDERS}>
                <AddOrder />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/orders-details/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADD_ORDERS}>
                <Details />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/create-order/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PULL_REQUEST}>
                <CreateOrder />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/purchased-product/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.PULL_REQUEST}>
                <PurchaseProduct />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/reports/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.REPORTS}>
                <Reports />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/view-reports/:id/:type/:name"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.REPORTS}>
                <OrdersReport />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/view-merchant/:id/:type/:name"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.REPORTS}>
                <TopupReport />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/admin-agent/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADMIN_AGENT}>
                <AdminAgents />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/add-agent/"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADMIN_AGENT}>
                <AddAgent />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-agent/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADMIN_AGENT}>
                <ViewAdminAgents />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/edit-agent/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.ADMIN_AGENT}>
                <EditAdminAgents />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="customer-support"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_SUPPORT}>
                <CustomerSupport />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="add-support"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_SUPPORT}>
                <AddSupport />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/edit-support/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_SUPPORT}>
                <EditSupport />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/view-support/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_SUPPORT}>
                <ViewSupport />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/logs"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.LOGS}>
                <Logs />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/bulkUpload"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.BULK_UPLOAD}>
                <BulkUpload />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/customer-info"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_INFO}>
                <CustomerInfo />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/customer-info-edit/:id"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.CUSTOMER_INFO}>
                <EditCustomerInfo />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="reseller-type"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.REGIONS}>
                <ResellerType />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/activity-logs"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.LOGS}>
                <ActivityLogs />
              </RoleProtectedRoute>
            }
          />
           <Route
            path="/master-stock-history/:masterProductId"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.MASTER_PRODUCT}>
                <MasterStockHistory />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/stock-transfer"
            element={
              <RoleProtectedRoute allowedRoles={AccessControl.STOCK_TRANSFER}>
                <StockTransfer />
              </RoleProtectedRoute>
            }
          />
        </Route>

        <Route path="*" element={<LoginForm />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
};

export default App;
